


import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from 'react';
import { FaPuzzlePiece } from "react-icons/fa6";
import { MdOutlineSwipe } from "react-icons/md";
import { TbDragDrop2 } from "react-icons/tb";
import { FaLightbulb } from "react-icons/fa";
import { IoAlert } from "react-icons/io5";
import { MdPsychology } from "react-icons/md";
import { HiLink } from 'react-icons/hi';
import { FaChartLine,FaAward  } from 'react-icons/fa';
import { FaClipboardList  } from 'react-icons/fa';
import { MdAssessment } from "react-icons/md";
import { MdOutlineAssessment } from "react-icons/md";
import {
  Box,
  Text,
  Flex,
  Button,
  Icon,
  List,
  ListItem,
  Img,
  Textarea,
  Input,
  Divider,
  Tooltip,
  FormLabel,
} from '@chakra-ui/react';
import Select from 'react-select';
import {

  MdAdd,
  MdCloudUpload,
  MdInbox,
  MdNote,
  MdNoteAdd,
  MdTextsms,
  MdDelete,
  MdOutlineStickyNote2,
} from 'react-icons/md';
import { BiSolidDuplicate } from 'react-icons/bi';
import Menu from '../components/Navigate';

import StrightConector from '../components/dragNdrop/strightConector';

import { TbHandClick, TbMessages } from 'react-icons/tb';
import { API_SERVER } from 'config/constant';

interface PropsNote {
   formData:any;
  reviews?: any;
  id?: number;
  gameId?: number;
  language?: any;
  seq?: any;
  index?: number;
  handleNDI?: any;
  name?: any;
  handleInput?: any;
  input?: any;
  getSeq?: any;
  handleMiniNDI?: any;
  duplicateSeq?: any;
  delSeq?: any;
  alphabet?: any;
  setNavigation: any;
  handleBlock: any;
  items?: any;
  formDataGamelanguageCode?: any;
  handleSelectBlock?: any;
  showSelectBlock?: any;
  setSelectBlock?: any;
  validation?: any;
  currentseq?: any;
  ShowReview?: any;
  showReflectionQuestions?:any;
  targetSequence?: any;
  blockOnFocusHanlder: any;
  blockOnBlurHanlder: any;
  setUploadedFiles:React.Dispatch<
  React.SetStateAction<Record<string, File>>
>;
}
interface Block {
  blockPrimarySequence: string;
  // Add other properties as needed
  content: string | undefined; // Adjust the type according to your data structure
}
const PreAssessmentCompo: React.FC<PropsNote> = ({
  showReflectionQuestions,
   formData,
  targetSequence,
  gameId,
  seq,
  index,
  name,
  handleInput,
  input,
  getSeq,
  duplicateSeq,
  delSeq,
 setUploadedFiles,
  setNavigation,
  handleBlock,
  handleSelectBlock,
  items,

  showSelectBlock,
  handleNDI,

  validation,
}) => {
  const textareaRef = useRef(null);
  const [uploadedImage, setUploadedImage] = useState<Record<string, string>>({});

  // const handleImageUpload = (e: ChangeEvent<HTMLInputElement>) => {
  //   const file = e.target.files?.[0];
  //   if (file && file.type.startsWith('image/')) {
  //     const reader = new FileReader();
  //     reader.onload = (event) => {
  //       const imageUrl = event.target?.result as string;
  //       setUploadedImage(imageUrl);
  //       handleInput({
  //         target: {
  //           name: `PreAssessment${seq.input}`,
  //           id: 'uploadedImage',
  //           value: imageUrl,
  //         },
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };
const handleImageUpload = (
  e: ChangeEvent<HTMLInputElement>,
  seqInput: number
) => {
  const file = e.target.files?.[0];
  if (!file || !file.type.startsWith('image/')) return;

  const key = `PreAssessment${seqInput}`;

  // ✅ Store real file
  setUploadedFiles(prev => ({
    ...prev,
    [key]: file,
  }));

  // ✅ Preview
  const reader = new FileReader();
  reader.onload = () => {
    setUploadedImage(prev => ({
      ...prev,
      [key]: reader.result as string,
    }));
  };
  reader.readAsDataURL(file);

  // ✅ Update form state with filename (NOT base64)
  handleInput({
    target: {
      name: key,
      id: 'uploadedImage',
      value: file.name,
    },
  });
};
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [input?.[`PreAssessment${seq.input}`]?.PreAssessment]);

  // Load existing image from input state
  useEffect(() => {
    const existingImage = input?.[`PreAssessment${seq.input}`]?.uploadedImage;
    if (existingImage && !uploadedImage) {
      setUploadedImage(existingImage);
    }
  }, [input?.[`PreAssessment${seq.input}`]?.uploadedImage]);

  const customButtonStyles = {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '15px',
    borderColor: '#ccc', // Optional: Change border color for disabled state
    borderWidth: '1px', // Add this line to set the border width
    borderStyle: 'solid', // Add this line to set the border style
    cursor: 'not-allowed', // Optional: Change cursor for disabled state
    padding: '5px 10px',
    width: '144px',
    // textAlign: "left",
    outerWidth: '10px',
    outline: 'none',
  };

  const customStyles = {
    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
    control: (provided: any, state: any) => ({
      ...provided,
      borderRadius: '15px',
      borderColor: 'inherit',
      background: 'transparent',
      // height: '45px',
      width: '130px',
      padding: '0 !important',
    }),
  };

  const handleMiniNDInewblock = (value?: any, seq?: any, i?: any) => {
    handleNDI(value);

    const maxInputItem = items.reduce(
      (max: any, item: any) => (item.input > max.input ? item : max),
      items[0],
    );
    let input = maxInputItem?.input ? maxInputItem.input + 1 : 1;
    if (value !== '') {
      handleSelectBlock(
        { value: input },
        input,
        `PreAssessment${seq.input}`,
        `PreAssessment${seq.input}`,
      );
    }
  };
  const MiniBox1 = (props: {
    seq?: any;
    i?: number;
    name?: any;
    bodyRef?: any;
  }) => {
    const { seq, i, name, bodyRef } = props;
    return (
      <Box
        position={'absolute'}
        background={'#fff'}
        p={'10px'}
        boxShadow={'1px 1px 17px #69627914'}
        borderRadius={'8px'}
        zIndex={99}
        className="MiniShowBox"
      >
         <List cursor={'pointer'}>
                  <ListItem
                    onClick={() => handleMiniNDInewblock('Note', seq, i)}
                    p={'10px'}
                    display={'flex'}
                    alignItems={'center'}
                    borderBottom={'2px solid #f1f1f170'}
                  >
                    <Icon as={MdOutlineStickyNote2} mr={'10px'} color={'#3311db'} />
                    Note
                  </ListItem>
        
                  <ListItem
                    onClick={() => handleMiniNDInewblock('Dialog', seq, i)}
                    p={'10px'}
                    display={'flex'}
                    alignItems={'center'}
                    borderBottom={'2px solid #f1f1f170'}
                  >
                    <Icon as={TbMessages} mr={'10px'} color={'#3311db'} />
                    Dialog
                  </ListItem>
                  <ListItem
                    onClick={() => handleMiniNDInewblock('Interaction', seq, i)}
                    p={'10px'}
                    display={'flex'}
                    alignItems={'center'}
                  >
                    <Icon as={TbHandClick} mr={'10px'} color={'#3311db'} />
                    Interaction
                  </ListItem>
                  <ListItem
                    onClick={() => handleMiniNDInewblock('Link', seq, i)}
                    p={'10px'}
                    display={'flex'}
                    alignItems={'center'}
                    borderBottom={'2px solid #f1f1f170'}
                  >
                    <Icon as={HiLink} mr={'10px'} color={'#3311db'} />
                    Link
                  </ListItem>
                  {showReflectionQuestions && (
                    <>
                      <ListItem
                        onClick={() => handleMiniNDInewblock('Reflection', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                      >
                        <Icon as={MdPsychology} mr={'10px'} color={'#3311db'} />
                        Reflection
                      </ListItem>
        
                      <ListItem
                        onClick={() => handleMiniNDInewblock('Overview', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                      >
                        <Icon as={FaClipboardList} mr={'10px'} color={'#3311db'} />
                        Overview
                      </ListItem>
                      <ListItem
                        onClick={() => handleMiniNDInewblock('KeyInsights', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                      >
                        <Icon as={FaChartLine} mr={'10px'} color={'#3311db'} />
                        KeyInsights
                      </ListItem>
                      <ListItem
                        onClick={() => handleMiniNDInewblock('PreAssessment', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                      >
                        <Icon as={MdAssessment} mr={'10px'} color={'#3311db'} />
                        PreAssessment
                      </ListItem>
                      <ListItem
                        onClick={() => handleMiniNDInewblock('PostAssessment', seq, i)}
                        p={'10px'}
                        display={'flex'}
                        alignItems={'center'}
                        borderBottom={'2px solid #f1f1f170'}
                      >
                        <Icon as={MdOutlineAssessment} mr={'10px'} color={'#3311db'} />
                        PostAssessment
                      </ListItem>
                        <ListItem
                                                              onClick={() => handleMiniNDInewblock('WehaveChoose', seq, i)}
                                                              p={'10px'}
                                                              display={'flex'}
                                                              alignItems={'center'}
                                                              borderBottom={'2px solid #f1f1f170'}
                                                            >
                                                              <Icon as={FaPuzzlePiece} mr={'10px'} color={'#3311db'} />
                                                              WehaveChoose
                                                            </ListItem>
                                                                       <ListItem
                                                              onClick={() => handleMiniNDInewblock('SwipeMiniGame', seq, i)}
                                                              p={'10px'}
                                                              display={'flex'}
                                                              alignItems={'center'}
                                                              borderBottom={'2px solid #f1f1f170'}
                                                            >
                                                              <Icon as={MdOutlineSwipe} mr={'10px'} color={'#3311db'} />
                                                              Swipe
                                                            </ListItem>
                                                                       <ListItem
                                                              onClick={() => handleMiniNDInewblock('DragForNow', seq, i)}
                                                              p={'10px'}
                                                              display={'flex'}
                                                              alignItems={'center'}
                                                              borderBottom={'2px solid #f1f1f170'}
                                                            >
                                                              <Icon as={TbDragDrop2} mr={'10px'} color={'#3311db'} />
                                                              Drag For Now 
                                                            </ListItem>
                      
                    </>
                  )}
                  {formData?.gameScenarioCompletion === 'true' && (
                    <ListItem
                      onClick={() =>
                        handleMiniNDInewblock('ScenarioCompletion', seq, i)
                      }
                      p={'10px'}
                      display={'flex'}
                      alignItems={'center'}
                      borderBottom={'2px solid #f1f1f170'}
                    >
                      <Icon as={FaAward} mr={'10px'} color={'#3311db'} />
                      ScenarioCompletion
                    </ListItem>
                  )}
                </List>
      </Box>
    );
  };

  const justClick = (event: any, seq: any, fieldType?: string) => {
    if (event.type === 'click') {
      const element = event.target;
      if (element) {
        element.classList.remove('non-caret');
        element.removeAttribute('readonly');
        element.focus();
      }
    }
  };

  return (
    <Flex padding={'10px 0'} alignItems={'start'} overflowY={'hidden'}>
      <Box className="block-action-icons">
        <Tooltip hasArrow label="Choose New Block">
          <div>
            <Icon
              as={MdAdd}
              transitionDelay={'0s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() => getSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Duplicate">
          <div>
            <Icon
              as={BiSolidDuplicate}
              transitionDelay={'0.1s !important'}
              fontSize={'18px'}
              color={'grey'}
              mr={'10px'}
              cursor={'pointer'}
              onClick={() =>
                duplicateSeq(seq, index, name, input?.[`PreAssessment${seq.input}`])
              }
            />
          </div>
        </Tooltip>
        <Tooltip hasArrow label="Delete PreAssessment">
          <div>
            <Icon
              as={MdDelete}
              transitionDelay={'0.2s !important'}
              fontSize={'18px'}
              color={'grey'}
              cursor={'pointer'}
              onClick={() => delSeq(seq, index, name)}
            />
          </div>
        </Tooltip>
      </Box>
      <Box
        className="block-id"
        mr={'10px'}
        w={'50px'}
        fontSize={'17px'}
        color={'#1b2559'}
        fontWeight={'700'}
      >
        {seq.id}
      </Box>
      <Box
        className="box-block"
        w={{ base: '100%', lg: 'auto' }}
        flexDirection={{ base: 'column', lg: 'row' }}
        display={'flex'}
        alignItems={'center'}
      >
        <Box
          className="block-input-text"
          mr={'10px'}
          mb={{ base: '10px', lg: '0px' }}
          w={{ base: '100%', lg: '400px' }}
          style ={{display:"flex",flexDirection:"column"}}
        >
          <Textarea
            ref={textareaRef}
            placeholder="PreAssessment Question"
            id="PreAssessment"
            className={`${seq.id}`}
            name={`PreAssessment${seq.input}`}
            onChange={handleInput}
            onClick={(e) => justClick(e, seq)}
            value={input?.[`PreAssessment${seq.input}`]?.PreAssessment || ''}
            isRequired={true}
            minHeight="65px"
            height={seq?.id === targetSequence?.id ? 'auto' : '65px !important'}
            borderRadius={'18px'}
            style={{
              overflow: 'hidden',
              border: validation?.[`PreAssessment${seq.input}`] && '2px solid red',
            }}
            overflow="auto" // Allow vertical scrolling
            _focusVisible={{
              borderColor: '#0000',
              border: '1px solid #e5e5e5',
              boxShadow: 'unset',
            }}
            tabIndex={0}
            readOnly={true}
          />
        </Box>
        <Box
                  className="block-input-text"
                  mr={'10px'}
                  mb={{ base: '10px', lg: '0px' }}
                  w={{ base: '100%', lg: '400px' }}
                >
                  <Textarea
                    placeholder="Validate Prompt"
                    id="validatePrompt"
                    className={`${seq.id}-validate`}
                    name={`PreAssessment${seq.input}`}
                    onChange={handleInput}
                    onClick={(e) => justClick(e, seq, 'validate')}
                    value={input?.[`PreAssessment${seq.input}`]?.validatePrompt || ''}
                    minHeight="65px"
                    height={seq?.id === targetSequence?.id ? 'auto' : '65px !important'}
                    borderRadius={'18px'}
                    style={{
                      overflow: 'hidden',
                    }}
                    overflow="auto"
                    _focusVisible={{
                      borderColor: '#0000',
                      border: '1px solid #e5e5e5',
                      boxShadow: 'unset',
                    }}
                    tabIndex={0}
                    readOnly={true}
                  />
                </Box>
                <Box
                  className="block-input-text"
                  mr={'10px'}
                  mb={{ base: '10px', lg: '0px' }}
                  w={{ base: '100%', lg: '400px' }}
                >
                  <Textarea
                    placeholder="Evaluation Prompt"
                    id="evaluationPrompt"
                    className={`${seq.id}-evaluation`}
                    name={`PreAssessment${seq.input}`}
                    onChange={handleInput}
                    onClick={(e) => justClick(e, seq, 'evaluation')}
                    value={input?.[`PreAssessment${seq.input}`]?.evaluationPrompt || ''}
                    minHeight="65px"
                    height={seq?.id === targetSequence?.id ? 'auto' : '65px !important'}
                    borderRadius={'18px'}
                    style={{
                      overflow: 'hidden',
                    }}
                    overflow="auto"
                    _focusVisible={{
                      borderColor: '#0000',
                      border: '1px solid #e5e5e5',
                      boxShadow: 'unset',
                    }}
                    tabIndex={0}
                    readOnly={true}
                  />
                </Box>
        {/* Image Upload Section */}
         <Box
          className="image-upload-section"
          mr={'10px'}
          mb={{ base: '10px', lg: '0px' }}
          w={{ base: '100%', lg: '200px' }}
        >
          <FormLabel fontSize={12} fontWeight={600} mb={2}>
            Upload Image
          </FormLabel>
          <Input
            type="file"
            accept="image/*"
           onChange={(e) => handleImageUpload(e, seq.input)}
            p={1}
            fontSize={12}
            height="40px"
          />
           {(() => {
            const uploadedImgSrc =
            uploadedImage?.[`PreAssessment${seq.input}`] ||
            (input?.[`PreAssessment${seq.input}`]?.uploadedImage
              ? `${API_SERVER}/${input[`PreAssessment${seq.input}`].uploadedImage}`
              : null);
            return uploadedImgSrc ? (
          
            <Box mt={2}>
              <Img
                src={uploadedImgSrc}
                h="60px"
                w="60px"
                borderRadius="8px"
                objectFit="cover"
                border="1px solid #e5e5e5"
              />
            </Box>
          ) : null;
          })()}
        </Box>
        <Box
          className="navigation-icon"
          h={'100%'}
          display={'flex'}
          alignItems={'center'}
          mr={'40px'}
          width={'auto'}
        >
          <Flex>
            <Box>
              <Tooltip hasArrow label="Add Navigations">
                <div>
                  <Menu
                    tabState={'leadDialog'}
                    id={seq.input}
                    for={`PreAssessment${seq.input}`}
                    setNavigation={setNavigation}
                    handleBlock={handleBlock}
                    items={items}
                    seq={seq}
                  />
                </div>
              </Tooltip>
            </Box>
            <Box
              ml={'4px'}
              cursor={'pointer'}
              display={
                input?.[`PreAssessment${seq.input}`]?.PreAssessmentleadShow ? 'block' : 'none'
              }
              zIndex={9999}
            >
              {input?.[`PreAssessment${seq.input}`]?.PreAssessmentleadShow === 'New Block' &&
              !input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate ? (
                // Render content for New Block
                <>
                  <MiniBox1 seq={seq} i={index} />
                </>
              ) : input?.[`PreAssessment${seq.input}`]?.PreAssessmentleadShow ===
                  'Select Block' &&
                !input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate ? (
                // Render select tag for Select Block
                <Select
                  placeholder={'Blocks...'}
                  id="Dialog"
                  name={`PreAssessment${seq.input}`}
                  menuPortalTarget={document.body}
                  styles={customStyles}
                  options={showSelectBlock.filter(
                    (option: any) => option.value !== seq.input,
                  )}
                  isSearchable={true}
                  className="react-select"
                  value={
                    showSelectBlock.find(
                      (option: any) =>
                        option.value ==
                        input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate,
                    ) || null
                  }
                  onChange={(e: any) =>
                    handleSelectBlock(
                      e,
                      seq.input,
                      `PreAssessment${seq.input}`,
                      `PreAssessment${seq.input}`,
                    )
                  }
                />
              ) : (
                // Render content for the 'else' condition
                <>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <StrightConector
                      name={
                        input?.[`PreAssessment${seq.input}`]?.PreAssessmentleadShow ===
                        'New Block'
                          ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate,
                            )?.label
                          : input?.[`PreAssessment${seq.input}`]?.PreAssessmentleadShow ===
                            'Select Block'
                          ? showSelectBlock.find(
                              (option: any) =>
                                option.value ==
                                input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate,
                            )?.label
                          : input?.[`PreAssessment${seq.input}`]?.PreAssessmentnavigate
                      }
                    />
                  </div>
                </>
              )}
            </Box>
          </Flex>
        </Box>
      </Box>
    </Flex>
  );
};

export default PreAssessmentCompo;
